import CreateWorkByWizardLayout from '@Scenes/WorkScenes/CreateWorkByWizardLayout'
import WorkDetailsStep from '@Scenes/WorkScenes/Steps/WorkDetailsStep'
import WritersStep from '@Scenes/WorkScenes/Steps/WritersSteps/WritersStep'
import WritersSharesRoleStep from '@Scenes/WorkScenes/Steps/WritersSteps/WritersSharesRolesStep'
import PublishersStep from '@Scenes/WorkScenes/Steps/PublishersSteps/PublishersStep'
import PublishersShareStep from '@Scenes/WorkScenes/Steps/PublishersSteps/PublishersShareStep'
import PublishersRelationsStep from '@Scenes/WorkScenes/Steps/PublishersSteps/PublishersRelationsStep'
import RecordingsStep from '@Scenes/WorkScenes/Steps/RecordingsStep'
import ReviewWorkFormScene from '@Scenes/WorkScenes/ReviewWorkFormScene'
import SubmissionStep from '@Scenes/WorkScenes/Steps/SubmissionStep'
import React from 'react'
import Navigation from '@App/navigation'
import { PERMISSIONS } from '@Const/permissions'
import PermissionCheck from '@Components/Utility/PermissionCheck'
import { STEP_ROUTES, WIZARD_ROUTE } from '@App/navigation/route'

const createCreateWorkByWizardRoutes = () => ({
    path: WIZARD_ROUTE,
    element: (
        <PermissionCheck
            requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.view_works]}
            orIsInternal
            reRouteLocation={Navigation.home.root()}
        >
            <CreateWorkByWizardLayout />
        </PermissionCheck>
    ),
    children: [
        {
            path: STEP_ROUTES.workDetails,
            element: <WorkDetailsStep />,
        },
        {
            path: STEP_ROUTES.writers,
            element: <WritersStep />,
        },
        {
            path: STEP_ROUTES.writersShares,
            element: <WritersSharesRoleStep />,
        },
        {
            path: STEP_ROUTES.publishers,
            element: <PublishersStep />,
        },
        {
            path: STEP_ROUTES.publishersShares,
            element: <PublishersShareStep />,
        },
        {
            path: STEP_ROUTES.publishersWriters,
            element: <PublishersRelationsStep />,
        },
        {
            path: STEP_ROUTES.recordings,
            element: <RecordingsStep />,
        },
        {
            path: STEP_ROUTES.review,
            element: <ReviewWorkFormScene workType="create-wizard" />,
        },
        {
            path: STEP_ROUTES.submission,
            element: <SubmissionStep />,
        },
    ],
})

export default createCreateWorkByWizardRoutes
